module.exports = __webpack_public_path__ + "static/media/forbes.b901b8fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Press/images/forbes.svg
// module id = 887
// module chunks = 0